module.exports = function() {
  return new Worker(__webpack_public_path__ + "f8d9c8887f619533ee12.worker.js");
};